
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/partnerstack",
      function () {
        return require("private-next-pages/destinations/partnerstack.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/partnerstack"])
      });
    }
  